<template>
    <div class="order-infoTab-section1">
        <div class="order-pay-record">
            <el-table :data="logs" border style="width: 100%" class="tabTopBorder" v-loading="loading">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-row :gutter="20">
                            <el-col :span="10" v-if="props.row.old_record.length > 0">
                                <p>变更前</p>
                                <p>
                                    <span v-for="(item, index) in props.row.old_record">
                                        <label>{{item.label}}</label> : {{item.value}} <br/>
                                    </span>
                                </p>
                            </el-col>
                            <el-col :span="10" v-if="props.row.record.length > 0">
                                <p>变更后</p>
                                <p>
                                    <span v-for="(item, index) in props.row.record">
                                        <span v-if="props.row.diff && props.row.diff[item.field]">
                                            <i style="color: #F56C6C;"><label>{{item.label}}</label> : {{item.value}}</i> <br/>
                                        </span>
                                        <span v-else>
                                            <label>{{item.label}}</label> : {{item.value}} <br/>
                                        </span>
                                    </span>
                                </p>
                            </el-col>
                        </el-row>
                        <!--                        <p v-if="props.row.messages.length > 0">-->
                        <!--                            <span v-for="(message, index) in props.row.messages">-->
                        <!--                                <label>{{message.label}}</label> : {{message.value}}-->
                        <!--                            </span>-->
                        <!--                        </p>-->
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="执行时间"></el-table-column>
                <el-table-column prop="operator_name" label="操作人"></el-table-column>
                <el-table-column prop="action_name" label="执行操作"></el-table-column>
                <el-table-column prop="model_name" label="修改类型"></el-table-column>
                <el-table-column prop="ip" label="执行时IP"></el-table-column>
                <el-table-column prop="memo" label="备注"></el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
    import CustomerService from "~/services/customer.js";
    import Pagination from "~/widgets/Pagination.vue";

    export default {
        name: "CustomerChangeLogs",
        components: {
            Pagination
        },
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
        },
        data() {
            return {
                logs: [],
                linkPage: null,
                loading: true,
            }
        },
        created() {
            if (this.logs.length == 0) {
                this.getChangeLogs({customer_id: this.customerId})
            }
        },
        methods: {

            getChangeLogs(params) {
                CustomerService.getChangeLogs(params).then(res => {
                    if (res.code == 0) {
                        this.logs = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                        this.loading = false;
                    }
                })
            },

            /**
             * 监听分页改变事件
             * @param pageParams
             */
            watchPageChange(pageParams) {
                this.getChangeLogs({
                    customer_id: this.customerId,
                    page: pageParams["page"],
                    perPage: pageParams["perPage"]
                });
            },

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/customer/ChangeLogs.vue